/**
 * Service API pour communiquer avec le backend
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Soumettre une demande de contact
 */
export const submitContactRequest = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/contact/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Erreur lors de l\'envoi de votre demande');
    }

    return await response.json();
  } catch (error) {
    // Log silencieux en production, l'erreur est propagée au composant
    throw error;
  }
};

/**
 * Soumettre une demande de devis
 */
export const submitQuoteRequest = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/contact/quote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Erreur lors de l\'envoi de votre demande');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Récupérer tous les services
 */
export const getServices = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/services`);
    
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des services');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Récupérer tous les projets/réalisations
 */
export const getProjects = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/projects`);
    
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des projets');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

/**
 * Récupérer tous les témoignages
 */
export const getTestimonials = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/testimonials`);
    
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des témoignages');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};
